module.exports = __webpack_public_path__ + "media/images/landing/useek_logo-bc21f5d8083880459e2c9cfd2e390ba0.png";